// extracted by mini-css-extract-plugin
export default {"purple02":"#838FAE","gray01":"#EFF1F3","blue01":"#2F3E54","RecentSearch":"RecentSearchLight__RecentSearch___yqHzr","clearAll":"RecentSearchLight__clearAll___ffFW8"};